var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatesEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79489 7.05601C4.79489 5.80701 5.80689 4.79501 7.05589 4.79401H8.08489C8.68189 4.79401 9.25389 4.55701 9.67789 4.13701L10.3969 3.41701C11.2779 2.53101 12.7099 2.52701 13.5959 3.40801L13.5969 3.40901L13.6059 3.41701L14.3259 4.13701C14.7499 4.55801 15.3219 4.79401 15.9189 4.79401H16.9469C18.1959 4.79401 19.2089 5.80601 19.2089 7.05601V8.08301C19.2089 8.68001 19.4449 9.25301 19.8659 9.67701L20.5859 10.397C21.4719 11.278 21.4769 12.71 20.5959 13.596L20.5949 13.597L20.5859 13.606L19.8659 14.326C19.4449 14.749 19.2089 15.321 19.2089 15.918V16.947C19.2089 18.196 18.1969 19.208 16.9479 19.208H16.9469H15.9169C15.3199 19.208 14.7469 19.445 14.3239 19.866L13.6039 20.585C12.7239 21.471 11.2929 21.476 10.4069 20.597C10.4059 20.596 10.4049 20.595 10.4039 20.594L10.3949 20.585L9.67589 19.866C9.25289 19.445 8.67989 19.209 8.08289 19.208H7.05589C5.80689 19.208 4.79489 18.196 4.79489 16.947V15.916C4.79489 15.319 4.55789 14.747 4.13689 14.324L3.41789 13.604C2.53189 12.724 2.52689 11.293 3.40689 10.407C3.40689 10.406 3.40789 10.405 3.40889 10.404L3.41789 10.395L4.13689 9.67501C4.55789 9.25101 4.79489 8.67901 4.79489 8.08101V7.05601",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43158 14.5718L14.5716 9.43176",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4955 14.5H14.5045",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4955 9.5H9.5045",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatesEmpty);
export default __webpack_public_path__ + "static/media/rates_empty.ee0884d12e6c1c87f8c41f0dc58a028d.svg";
export { ForwardRef as ReactComponent };